import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const VariantSelectorSection = styled.section`
    padding-top: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('600')};
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray200')};
`;

export const BadgeBlockTitle = styled.div`
    display: flex;
    align-items: center;
    margin-top: 0;
    border-top: 1px solid ${getPurpurColor('gray200')};
    padding-top: ${getPurpurSpacing('600')};
    margin-bottom: ${getPurpurSpacing('150')};
    gap: ${getPurpurSpacing('200')};

    &:first-child {
        padding-top: ${getPurpurSpacing('300')};
        border-top: none;
    }

    & ~ & {
        margin-top: ${getPurpurSpacing('600')};
    }
`;

export const BadgeBlockOutOfStockLabel = styled.mark`
    background-color: unset;
    color: ${getPurpurColor('textStatusErrorMedium')};
    font-size: 0.875rem;
    font-weight: normal;
`;

export const BadgeBlockContainer = styled.div.attrs({ role: 'radiogroup' })`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('200')};
    margin-bottom: ${getPurpurSpacing('200')};
`;
